import Repository from "./Repository";
import store from "@/store/index";

function generateParams(){
    const uid = store.get("account/id");
    const profileData = JSON.parse(JSON.stringify(store.get("ui")));

    let saveData = {
        employmentPostPhD: profileData.employmentPostPhD,
        employmentPrePhD: profileData.employmentPrePhD,
        books: profileData.books,
        papers: profileData.papers,
        research: profileData.research,
        consulting: profileData.consulting,
        awards: profileData.awards,
        bachelors: profileData.bachelors,
        masters: profileData.masters,
        application: profileData.application,
        contact: profileData.contact,
        thesis: profileData.thesis,
        personal: profileData.personal,
        referee1: profileData.referee1,
        referee2: profileData.referee2,
        uid: uid
    };

    return saveData;
}

export default {
    saveApplicationProfile(){
        return Repository.post('completed_registration', generateParams());
    },
    
    checkProfile(){
        return Repository.get('check_profile');
    }
};
